import HttpService from './HttpService'
const _http = new HttpService()

export default {
  find: (payload) => {
    return _http.post('/api/tracking', payload)
  }
}